import { EListingCardLayouts, ListingCard } from "@organic-return/foundation-react/src/components/Listing/ListingCard"
import { WsrvImage } from "@organic-return/foundation-react/src/components/Media"
import { Search } from "@organic-return/foundation-react/src/components/Search/Search"
import { EWsrvTransform } from "@organic-return/foundation-react/src/lib/Media/util"
import { graphql, Link, navigate, useStaticQuery } from "gatsby"
import React, { useEffect, useState } from "react"
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa"
import { useSiteContext } from "../common/SiteContext"
import Select from "react-select";
import { EListingVitalsLayout } from "@organic-return/foundation-react/src/components/Listing"
import TabbedContentBlade, { ITabContent } from "@organic-return/foundation-react/src/components/Blades/TabbedContentBlade"
import { ContactCard, EContactCardLayout } from "@organic-return/foundation-react/src/components/Contact"
import { EntrySearch } from "@organic-return/foundation-react/src/components/Search"
import { BackgroundImage } from "@organic-return/foundation-react/src/components/Media"

const OfficesSearch = ({ module }) => {
  const siteContext = useSiteContext()
  const data = useStaticQuery(graphql`
      query {
        allListing(filter: {exclusive: {eq: true}, status: {ne: "Closed"}}, sort: {order: DESC, fields: price}) {
          nodes {
            id
            baths
            address {
              city
              street1
              county
              postal
              text
              street2
              state
            }
            beds
            lotacres    
            price
            sqft
            status  
            exclusive            
            flags            
            defaultImage {
              dimensions
              url
            }
            path
            location {
              lat
              lng
            }
            office {
              id
            }
            officeName
          }
        }
        allPerson(sort: {fields: last, order: ASC}) {
          nodes { 
            email
            first
            fullName
            last        
            path
            phone
            phoneMobile
            phoneOffice
            workTitle            
            photos {
              url
            }
            office {
              id
            }
            officeName
          }
        }
        allOffice(sort: {fields: fullName, order: ASC}) {
          nodes {
            id
            photos {
              url
            }
            address {              
              city
              state
              postal
              street1
              street2
              country
              county
            }
            phone
            email
            fullName
            description
          }
        }
        
      }
    `)

  let cardClass = "w-[480px]"
  let cardImageWidth = 480
  if (module.customFields?.cardSize == "large") {
    cardClass = "w-[640px]"
    cardImageWidth = 640
  }

  let agentsEntrySearch = (
    <EntrySearch
      onSubmit={async filters => {
        const params = new URLSearchParams({
          filters: JSON.stringify(filters),
        })
        await navigate(
          "#" + params.toString()
        )
      }}
      className="w-full max-w-screen-lg mx-auto"
      title={module.customFields.searchFormTitle}
      {...siteContext.peopleEntrySearchProps}
    />
  )

  if (module.customFields.searchFormBackgroundImage?.url) {
    agentsEntrySearch = (
      <BackgroundImage
        className="relative w-full pt-44"
        src={module.customFields.searchFormBackgroundImage?.url}
        sizesAndAspect={[
          { media: "max-width: 420px", width: 640 },
          { media: "min-width: 421px", width: 640 },
          { media: "min-width: 640px", width: 768 },
          { media: "min-width: 768px", width: 1024 },
          { media: "min-width: 1024px", width: 1280 },
          { media: "min-width: 1280px", width: 1440 },
          { media: "min-width: 1440px", width: 1536 },
          { media: "min-width: 1536px", width: 2560 },
        ]}
      >
        <div className="relative inset-x-0 bottom-0 pt-10 pb-11 bg-gradient-to-t from-black">
          {agentsEntrySearch}
        </div>
      </BackgroundImage>
    )
  }
  else {
    agentsEntrySearch = (
      <div className="inverted relative pt-44 pb-20">
        {agentsEntrySearch}
      </div>
    )
  }

  let offices: any[] = data.allOffice.nodes
  offices?.forEach((office) => {
    const agents = data.allPerson?.nodes?.filter(agent => agent.office.some(item => item.id == office.id))
    office["agents"] = agents
    const listings = data.allListing?.nodes?.filter(listing => listing.office.some(item => item.id == office.id))
    office["listings"] = listings
  })
  const officesOptions = offices?.map(office => {
    return {
      label: office.fullName,
      value: office.id,
    }
  })

  const officeTabs = (office) => {
    const tabPanels: ITabContent[] = [];

    office?.agents && office.agents.length > 0 &&
      tabPanels.push({
        contentClassName: "w-full max-w-screen-lg mx-auto",
        contentId: "officeagents",
        tabTitle: `${office.fullName} Agents`,
        content: (
          <Search
            primaryFilters={siteContext.peopleEntrySearchProps?.standardFilters}
            key={office?.id}
            index={office?.agents}
            className="agent-search"
            pageSize={12}
            pagerBottom={true}
            renderItem={(item, index) => {
              return (
                <ContactCard
                  contact={item}
                  layout={EContactCardLayout.horizontal}
                  maxWidthImage={200}
                  className="w-full sm:w-1/2 xl:w-1/3 p-4"
                  showVCard={false}
                  buttonText={`About ${item.first || item.fullName}`}
                  key={index}
                  linkFunc={props => {
                    return (
                      <Link
                        to={props.href ?? ""}
                        className={`text-inherit ${props.className}`}
                        key={props.key}
                        title={props.title}
                      >
                        <>{props.children}</>
                      </Link>
                    )
                  }}
                  {...siteContext.globalPeopleSearchCardProps}
                />
              )
            }}
            preRenderItem={(item, index) => {
              return (
                <a key={index} href={item.path}></a>
              )
            }}
          />
        )
      })

    office?.listings && office.listings.length > 0 &&
      tabPanels.push({
        contentClassName: "w-full",
        contentId: "officelistings",
        tabTitle: `${office.fullName} Listings`,
        content: (
          <Search
            key={office?.id}
            index={office?.listings}
            className="listing-search"
            pageSize={12}
            pagerBottom={true}
            renderItem={(item, index) => {
              return (
                <ListingCard
                  key={index}
                  listing={item}
                  layout={EListingCardLayouts.vertical}
                  className={`${cardClass} max-w-full`}
                  maxWidthImage={cardImageWidth}
                  linkImage={true}
                  linkFunc={props => {
                    return (
                      <Link
                        to={props.href ?? ""}
                        className={`text-inherit ${props.className}`}
                        key={props.key}
                        title={props.title}
                      >
                        <>{props.children}</>
                      </Link>
                    )
                  }}
                  {...siteContext.globalListingCardProps}
                  vitalsLayout={
                    module.customFields?.cardLayout ||
                    EListingVitalsLayout.column2Border1
                  }
                />
              )
            }}
            preRenderItem={(item, index) => {
              return (
                <a key={index} href={item.path}></a>
              )
            }}
          />
        )
      })

    return (
      <TabbedContentBlade
        key={office?.id}
        tabs={tabPanels}
        className="w-full"
      />
    )
  }

  const [currentOffice, setCurrentOffice] = useState<any>(offices![0])
  const [tabs, setTabs] = useState<any>(officeTabs(offices![0]?.listings))
  useEffect(() => {
    const currentOfficeTabs = officeTabs(currentOffice)
    setTabs(currentOfficeTabs)
  }, [currentOffice]);

  const onOfficeChange = (option: any) => {
    const selectedOffice = offices.find(item => item.id == option.value)
    setCurrentOffice(selectedOffice)
  }
  const officeFilter = (
    <div className="mx-auto flex justify-center items-baseline mt-16 px-6 py-5 bg-body-bg-inverted text-xs">
      <span className="text-inherit uppercase font-bold">Sort by:</span>
      <Select
        name="offices"
        isMulti={false}
        options={officesOptions}
        onChange={(option) => onOfficeChange(option)}
        styles={{
          control: (base: object) => ({
            ...base,
            border: "transparent",
            background: "var(--color-body-bg-inverted)",
          }),
          indicatorSeparator: (base: object) => ({
            ...base,
            display: "none"
          }),
          dropdownIndicator: (base: object) => ({
            ...base,
            color: "var(--color-body-text-inverted)"
          }),
        }}
        defaultValue={officesOptions![0]}
      />
    </div>
  )

  return (
    <>
      {agentsEntrySearch}
      <div className="offices-search w-full max-w-screen-xl mx-auto py-20 flex flex-col gap-y-24">
        {officeFilter}
        {currentOffice && (
          <div className="w-full max-w-screen-lg mx-auto flex flex-row flex-wrap px-2">
            <WsrvImage
              urlParams={{
                originURL: currentOffice.photos![0]?.url,
                preset: EWsrvTransform.limit,
              }}
              imgProps={{
                className: "w-full aspect-square object-cover object-center",
                wrapperClassName: "lg:w-5/12"
              }}
            />
            <div className="lg:w-7/12 lg:pl-14">
              <h2 className="text-ellipsis overflow-hidden">{currentOffice.fullName}</h2>
              {currentOffice.description && <div className="pb-8" dangerouslySetInnerHTML={{ __html: currentOffice.description }}></div>}
              {currentOffice.address && (<address className="flex flex-row justify-start items-center gap-5 pb-3 not-italic">
                <FaMapMarkerAlt />
                <span>
                  {`${currentOffice.address.street1}${currentOffice.address.street2 && ` ${currentOffice.address.street2}`}`} <br />
                  {`${currentOffice.address.city}${currentOffice.address.state && `, ${currentOffice.address.state}`}${currentOffice.address.postal && `, ${currentOffice.address.postal}`}`}
                </span>
              </address>)}
              {currentOffice.phone && <a className="inline-flex text-body-text-inverted flex-row justify-start items-center gap-5 pb-14 cursor-pointer">
                <FaPhoneAlt />
                <span>{currentOffice.phone}</span>
              </a>}
              {currentOffice.email && (
                <a className="font-bold tracking-widest block w-max bg-accent py-4 px-10 text-white text-xs uppercase" href={`mailto:${currentOffice.email}`}>{`Email Our ${currentOffice.fullName}`}</a>
              )}
            </div>
          </div>
        )}
        {tabs}
      </div>
    </>
  )
}

export default OfficesSearch